import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./components/pages/Dashboard/Dashboard";
import Login from "./components/pages/Login/Login";
import AddResident from "./components/pages/AddResident/AddResident";
// import ResidentManagement from "./components/pages/ResidentManagement/ResidentManagement";
import VisitorsManagement from "./components/pages/VisitorsManagement/VisitorsManagement";
// import Building from "./components/pages/BuildingManagement/Building";
import CommitteeManagement from "./components/pages/CommitteeManagement/CommitteeManagement";
import Agencies from "./components/pages/Agencies/Agencies";
import AddAgency from "./components/pages/Agencies/AddAgency";
import EditAgency from "./components/pages/Agencies/EditAgency";
import Guards from "./components/pages/Guards/Guards";
import AddGuards from "./components/pages/Guards/AddGuards";
import ConfigureSecuritySpots from "./components/pages/ConfigureSecuritySpots/ConfigureSecuritySpots";
import GuardAssignment from "./components/pages/GuardAssignment/GuardAssignment";
import ConfigureBuilding from "./components/pages/ConfigureBuilding/ConfigureBuilding";
import ConfigureBuildingTable from "./components/pages/ConfigureBuilding/ConfigureBuildingTable";
import Amenities from "./components/pages/Amenities/Amenities";
import AddedGuardSucce from "./components/pages/Guards/AddedGuardSucce";
import VisitorsManagement2 from "./components/pages/VisitorsManagement/VisitorsManagement2";
import ResidentManagement2 from "./components/pages/ResidentManagement/ResidentManagement2";
import ApplicationDevelopement from "./components/pages/ApplicationDevelopement/ApplicationDevelopement";
import GuardApplication from "./components/pages/ApplicationDevelopement/GuardApplication";
import ActiveServiceProviders from "./components/pages/ServiceProviders/ActiveServiceProviders";
import AddServiceProvider from "./components/pages/ServiceProviders/AddServiceProvider";
import DetailsViewOfServicePro from "./components/pages/ServiceProviders/DetailsViewOfServicePro";
import EditResident from "./components/pages/ResidentManagement/EditResident";
import EditGuard from "./components/pages/Guards/EditGuard";
import EditServiceProvider from "./components/pages/ServiceProviders/EditServiceProvider";
import ServiceProDetails from "./components/pages/Dashboard/ServiceProDetails";
import ResidentReport from "./components/pages/Reports/ResidentReport";
import VisitorsReport from "./components/pages/Reports/VisitorsReport";
import ServiceProviderReport from "./components/pages/Reports/ServiceProviderReport";
import SecurityGuardsReport from "./components/pages/Reports/SecurityGuardsReport";
import AllServiceProviders from "./components/pages/ServiceProviders/AllServiceProviders";
import VerifyServiceProvider from "./components/pages/Dashboard/VerifyServiceProvider";
import RejectedProviders from "./components/pages/ServiceProviders/RejectedProviders";
import ResidentManInfoView from "./components/pages/ResidentManagement/ResidentManInfoView";
import UserProfile from "./components/pages/UserProfile/UserProfile";
import CreateInvoice from "./components/pages/CreateInvoice/CreateInvoice";
import Payments from "./components/pages/Payments/Payments";
import InvoiceListing from "./components/pages/CreateInvoice/InvoiceListing";
import InvoiceListingNew from "./components/pages/CreateInvoice/InvoiceListingNew";
// import InvoicePreview from "./components/pages/CreateInvoice/InvoicePreview";
import PaidInvoicesListing from "./components/pages/CreateInvoice/PaidInvoicesListing";
import UnpaidInvoicesListing from "./components/pages/CreateInvoice/UnpaidInvoicesListing";
import InvoiceSettings from "./components/pages/CreateInvoice/InvoiceSettings";
// import DashboardNew from "./components/pages/Dashboard/DashboardNew";
import NoticeBoardPage from "./components/pages/NoticeBoard/NoticeBoardPage";
import AddResidentNew from "./components/pages/AddResident/AddResidentNew";
import EditResidentNew from "./components/pages/ResidentManagement/EditResidentNew";
import EditGuardNew from "./components/pages/Guards/EditGuardNew";
import AddSociety from "./components/pages/ConfigureBuilding/AddSociety";
import AddNewSpot from "./components/pages/ConfigureSecuritySpots/AddNewSpot";
import AssignDuty from "./components/pages/GuardAssignment/AssignDuty";
import SendInvoice from "./components/pages/CreateInvoice/SendInvoice";
import CreateInvoiceWithTab from "./components/pages/CreateInvoice/CreateInvoiceWithTab";
import AllAmenities from "./components/pages/Amenities/AllAmenities";
import RejectedAmenities from "./components/pages/Amenities/RejectedAmenities";
import BookedAmenities from "./components/pages/Amenities/BookedAmenities";
import PendingAmenities from "./components/pages/Amenities/PendingAmenities";
import BookAmenities from "./components/pages/Amenities/BookAmenities";
import AddAmenity from "./components/pages/Amenities/AddAmenity";
import BookAmenitiesDetails from "./components/pages/Amenities/BookAmenitiesDetails";
import BookAmenitiesCalender from "./components/pages/Amenities/BookAmenitiesCalender";
import BookAmenitiesDetailsNew from "./components/pages/Amenities/BookAmenitiesDetailsNew";
import BookAmenityNew from "./components/pages/Amenities/BookAmenityNew";
import DiscussionForumPage from "./components/pages/NoticeBoard/DiscussionForumPage";
import PollsPage from "./components/pages/PollsPage/PollsPage";
import ComplaintsPage from "./components/pages/Complaints/ComplaintsPage";
import AddEvent from "./components/pages/Dashboard/AddEvent";
import CreateInvoiceNew from "./components/pages/CreateInvoice/CreateInvoiceNew";
import VerificationInProgress from "./components/pages/ServiceProviders/VerificationInProgress";
import NewProvider from "./components/pages/ServiceProviders/NewProvider";
import MonthlyMaintenInvoicesPreview from "./components/pages/CreateInvoice/MonthlyMaintenInvoicesPreview";
import MiscellaneousInvoicesPreview from "./components/pages/CreateInvoice/MiscellaneousInvoicesPreview";
import BuildingYes from "./components/pages/ConfigureBuilding/BuildingYes";
import BuildingDetails from "./components/pages/ConfigureBuilding/BuildingDetails";
import TenentManagInfoView from "./components/pages/ResidentManagement/TenentManagInfoView";
import EditBuilding from "./components/pages/ConfigureBuilding/EditBuilding";
import EditInvoice from "./components/pages/CreateInvoice/EditInvoice";
import Tickets from "./components/pages/Tickets/Tickets";
import EditAmenity from "./components/pages/Amenities/EditAmenity";
import CreateNewTemplate from "./components/pages/CreateInvoice/CreateNewTemplate";
import SendInvoiceTo from "./components/pages/CreateInvoice/SendInvoiceTo";
import SendOtp from "./components/pages/Login/SendOtp";
import ChangePassword from "./components/pages/Login/ChangePassword";
import AllSociety from "./components/pages/AllSociety/AllSociety";
import AssignRights from "./components/pages/AssignRights";
import SocietyAdmin from "./components/pages/SocietyAdmin/SocietyAdmin";
import ManageSOS from "./components/pages/ManageSOS/ManageSOS";
import ApartmentHistory from "./components/pages/ApartmentHistory/ApartmentHistory";
import AddDutyPage from "./components/pages/GuardAssignment/AddDutyPage";
import ViewEvents from "./components/pages/Dashboard/ViewEvents";
import Aboutus from "./components/pages/Aboutus/Aboutus";
import TechSupport from "./components/pages/TechSupport/TechSupport";
import ServiceTypePage from "./components/pages/ServiceProviders/ServiceTypePage";
import InOutLogs from "./components/pages/ServiceProviders/InOutLogs";
import ServiceProviderHistory from "./components/pages/ServiceProviders/ServiceProviderHistory";
import MasterCalculations from "./components/pages/ConfigureBuilding/MasterCalculations";
import WaveLateFee from "./components/pages/CreateInvoice/WaveLateFee";
import EditMiscellaneousInvoices from "./components/pages/CreateInvoice/EditMiscellaneousInvoices";
import PrintMonthlyInvoice from "./components/pages/CreateInvoice/PrintMonthlyInvoice";
import PrintMiscelliniousInvoice from "./components/pages/CreateInvoice/PrintMiscelliniousInvoice";
import MobileLogin from "./MobileScreens/Screens/MobileLogin/MobileLogin";
import MobileForgotPassword from "./MobileScreens/Screens/MobileForgotPassword/MobileForgotPassword";
import HomePage from "./components/MarketingWebsite/HomePage";
import HomeTop from "./components/MarketingWebsite/HomeTop";
import HomeFooter from "./components/MarketingWebsite/HomeFooter";

import MobileDashboard from "./MobileScreens/Screens/MobileDashboard/MobileDashboard";
import MobFamilyDetails from "./MobileScreens/Screens/MobFamilyDetails/MobFamilyDetails";
import MobileProfile from "./MobileScreens/Screens/MobileProfile/MobileProfile";
// import MobileBottomNav from "./MobileScreens/Screens/MobileComponents/MobileBottomNav";
import MobileApartment from "./MobileScreens/Screens/MobileApartment/MobileApartment";
import MobileEmergency from "./MobileScreens/Screens/MobileEmergency/MobileEmergency";
import MobileVisitor from "./MobileScreens/Screens/MobileVisitor/MobileVisitor";
import MobileNoticeBoard from "./MobileScreens/Screens/MobileNoticeBoard/MobileNoticeBoard";
import MobileNoticeBoardDetails from "./MobileScreens/Screens/MobileNoticeBoard/MobileNoticeBoardDetails";
import MobileComplains from "./MobileScreens/Screens/MobileComplaints/MobileComplains";
import MobilePolls from "./MobileScreens/Screens/MobilePolls/MobilePolls";
import MobileSupportTicket from "./MobileScreens/Screens/MobileSupportTickets/MobileSupportTicket";
import MobileUpcomingEvents from "./MobileScreens/Screens/MobileUpcomingEvents/MobileUpcomingEvents";
import MobileInvoice from "./MobileScreens/Screens/MobileInvoice/MobileInvoice";
import MobileComplainDetails from "./MobileScreens/Screens/MobileComplaints/MobileComplainDetails";
import GuardFeatures from "./components/MarketingWebsite/GuardFeatures";
import ResidentFeatures from "./components/MarketingWebsite/ResidentFeatures";
import MobileUnpaidInvoiceDetails from "./MobileScreens/Screens/MobileInvoice/MobileUnpaidInvoiceDetails";
import MobilePayNow from "./MobileScreens/Screens/MobileInvoice/MobilePayNow";
import MobileAddPreapproval from "./MobileScreens/Screens/MobileVisitor/MobileAddPreapproval";
import MobileVisitorDetails from "./MobileScreens/Screens/MobileVisitor/MobileVisitorDetails";
import MobileDiscussionForum from "./MobileScreens/Screens/MobileDiscussionForum/MobileDiscussionForum";
import MobileCreateDiscussionForum from "./MobileScreens/Screens/MobileDiscussionForum/MobileCreateDiscussionForum";
import MobileDiscussionDetails from "./MobileScreens/Screens/MobileDiscussionForum/MobileDiscussionDetails";
import MobileSupportTicketDetails from "./MobileScreens/Screens/MobileSupportTickets/MobileSupportTicketDetails";
import MobileSosScreen from "./MobileScreens/Screens/MobileSOSScreen/MobileSosScreen";
import MobileEditProfile from "./MobileScreens/Screens/MobileProfile/MobileEditProfile";
import MobileVehicleinfo from "./MobileScreens/Screens/MobileProfile/MobileVehicleinfo";
import MobileTenantInfo from "./MobileScreens/Screens/MobileProfile/MobileTenantInfo";
import MobileTenantVehicle from "./MobileScreens/Screens/MobileProfile/MobileTenantVehicle";
import OwnerVehicleDetails from "./MobileScreens/Screens/MobileProfile/OwnerVehicleDetails";
import MobileTenantDetails from "./MobileScreens/Screens/MobileProfile/MobileTenantDetails";
import MobileTenantVehicleDetails from "./MobileScreens/Screens/MobileProfile/MobileTenantVehicleDetails";
import MobileGroup from "./MobileScreens/Screens/MobileGroup/MobileGroup";
import MobileAddMember from "./MobileScreens/Screens/MobileGroup/MobileAddMember";
import MobileServiceProvider from "./MobileScreens/Screens/MobileServiceProvider.js/MobileServiceProvider";
import MobileServiceProviderDetails from "./MobileScreens/Screens/MobileServiceProvider.js/MobileServiceProviderDetails";
import MobileAddServiceProvider from "./MobileScreens/Screens/MobileServiceProvider.js/MobileAddServiceProvider";
import MobileSpecificServiceProvider from "./MobileScreens/Screens/MobileServiceProvider.js/MobileSpecificServiceProvider";
import MobileResidentDirectory from "./MobileScreens/Screens/MobileResidentDirectory/MobileResidentDirectory";
import MobileMarketPlaceBuyer from "./MobileScreens/Screens/MobileMarketPlace/MobileMarketPlaceBuyer";
import MobileMarketPlaceSeller from "./MobileScreens/Screens/MobileMarketPlace/MobileMarketPlaceSeller";
import MobileMarketDetailsBuyer from "./MobileScreens/Screens/MobileMarketPlace/MobileMarketDetailsBuyer";
import MobileMarkerDetailsSeller from "./MobileScreens/Screens/MobileMarketPlace/MobileMarkerDetailsSeller";
import MobileAddListing from "./MobileScreens/Screens/MobileMarketPlace/MobileAddListing";
import MobileChatList from "./MobileScreens/Screens/MobileMarketPlace/MobileChatList";
import MobileChatScreen from "./MobileScreens/Screens/MobileMarketPlace/MobileChatScreen";
import MobileAddEvent from "./MobileScreens/Screens/MobileUpcomingEvents/MobileAddEvent";
import MobileFoodOrderOption from "./MobileScreens/Screens/MobileFoodOrder/MobileFoodOrderOption";
import MobileFoodOrder from "./MobileScreens/Screens/MobileFoodOrder/MobileFoodOrder";
import MobileMyOrder from "./MobileScreens/Screens/MobileFoodOrder/MobileMyOrder";
import PrivacyPolicy from "../src/components/MarketingWebsite/PrivacyPolicy";
import AdminFeatures from "./components/MarketingWebsite/AdminFeatures";


import InvoiceReports from "./components/pages/CreateInvoice/InvoiceReports";
import ResiproPrivacyPolicy from "./components/MarketingWebsite/ResiproPrivacyPolicy";

function App() {
  return (
    <>
      {/* <Top />
      <Left /> */}
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="Login" element={<Login />} />
          <Route path="Dashboard" element={<Dashboard />} />
          {/* <Route path="DashboardNew" element={<DashboardNew />} /> */}
          <Route path="AddResident" element={<AddResident />} />
          {/* <Route path="ResidentManagement" element={<ResidentManagement />} /> */}
          <Route path="ResidentManagement2" element={<ResidentManagement2 />} />

          <Route path="VisitorsManagement" element={<VisitorsManagement />} />
          <Route path="CommitteeManagement" element={<CommitteeManagement />} />

          <Route path="Agencies" element={<Agencies />} />
          <Route path="AddAgency" element={<AddAgency />} />
          <Route path="EditAgency" element={<EditAgency />} />
          {/* <Route path="Building" element={<Building />} /> */}

          <Route path="Guards" element={<Guards />} />
          <Route path="AddGuards" element={<AddGuards />} />
          <Route
            path="ConfigureSecuritySpots"
            element={<ConfigureSecuritySpots />}
          />
          <Route path="GuardAssignment" element={<GuardAssignment />} />
          <Route path="ConfigureBuilding" element={<ConfigureBuilding />} />
          <Route
            path="ConfigureBuildingTable"
            element={<ConfigureBuildingTable />}
          />
          <Route path="Amenities" element={<Amenities />} />
          <Route path="AddedGuardSucce" element={<AddedGuardSucce />} />
          <Route path="VisitorsManagement2" element={<VisitorsManagement2 />} />
          <Route
            path="ApplicationDevelopement"
            element={<ApplicationDevelopement />}
          />
          <Route path="GuardApplication" element={<GuardApplication />} />
          <Route
            path="ActiveServiceProviders"
            element={<ActiveServiceProviders />}
          />
          <Route path="AddServiceProvider" element={<AddServiceProvider />} />
          <Route
            path="DetailsViewOfServicePro/:sid"
            element={<DetailsViewOfServicePro />}
          />
          <Route path="EditResident/:eid" element={<EditResident />} />
          <Route path="EditGuard/:egid" element={<AddGuards />} />
          <Route path="EditGuardNew/:egid" element={<EditGuardNew />} />

          <Route path="EditServiceProvider" element={<EditServiceProvider />} />
          <Route path="ServiceProDetails" element={<ServiceProDetails />} />
          <Route path="ResidentReport" element={<ResidentReport />} />
          <Route path="VisitorsReport" element={<VisitorsReport />} />
          <Route
            path="ServiceProviderReport"
            element={<ServiceProviderReport />}
          />
          <Route
            path="SecurityGuardsReport"
            element={<SecurityGuardsReport />}
          />
          <Route path="AllServiceProviders" element={<AllServiceProviders />} />
          <Route
            path="VerifyServiceProvider"
            element={<VerifyServiceProvider />}
          />
          <Route path="RejectedProviders" element={<RejectedProviders />} />
          <Route
            path="ResidentManInfoView/:rid"
            element={<ResidentManInfoView />}
          />
          <Route path="UserProfile" element={<UserProfile />} />
          <Route path="CreateInvoice" element={<CreateInvoice />} />
          <Route path="InvoiceListing" element={<InvoiceListing />} />
          <Route path="InvoiceListingNew" element={<InvoiceListingNew />} />
          <Route path="InvoiceReports" element={<InvoiceReports />} />

          {/* <Route path="InvoicePreview/:invId" element={<InvoicePreview />} /> */}
          <Route path="PaidInvoicesListing" element={<PaidInvoicesListing />} />
          <Route
            path="UnpaidInvoicesListing"
            element={<UnpaidInvoicesListing />}
          />
          <Route path="InvoiceSettings" element={<InvoiceSettings />} />
          <Route path="Payments" element={<Payments />} />
          <Route path="NoticeBoardPage" element={<NoticeBoardPage />} />
          <Route path="AddResidentNew" element={<AddResidentNew />} />
          <Route path="EditResidentNew" element={<EditResidentNew />} />
          <Route path="EditGuard" element={<EditGuard />} />
          <Route path="AddSociety" element={<AddSociety />} />
          <Route path="AddNewSpot" element={<AddNewSpot />} />
          <Route path="AssignDuty" element={<AssignDuty />} />
          <Route path="SendInvoice" element={<SendInvoice />} />
          <Route
            path="CreateInvoiceWithTab"
            element={<CreateInvoiceWithTab />}
          />
          <Route path="AllAmenities" element={<AllAmenities />} />
          <Route path="BookedAmenities" element={<BookedAmenities />} />
          <Route path="RejectedAmenities" element={<RejectedAmenities />} />
          <Route path="PendingAmenities" element={<PendingAmenities />} />
          <Route path="BookAmenities" element={<BookAmenities />} />
          <Route
            path="BookAmenitiesDetails"
            element={<BookAmenitiesDetails />}
          />
          <Route
            path="BookAmenitiesCalender"
            element={<BookAmenitiesCalender />}
          />
          <Route path="AddAmenity" element={<AddAmenity />} />
          <Route path="EditAmenity" element={<EditAmenity />} />
          <Route
            path="BookAmenitiesDetailsNew"
            element={<BookAmenitiesDetailsNew />}
          />
          <Route path="BookAmenityNew" element={<BookAmenityNew />} />
          <Route path="DiscussionForumPage" element={<DiscussionForumPage />} />
          <Route path="PollsPage" element={<PollsPage />} />
          <Route path="ComplaintsPage" element={<ComplaintsPage />} />
          <Route path="AddEvent" element={<AddEvent />} />
          <Route path="EditEvent/:id" element={<AddEvent />} />
          <Route path="ViewEvents" element={<ViewEvents />} />
          <Route path="CreateInvoiceNew" element={<CreateInvoiceNew />} />
          <Route
            path="VerificationInProgress"
            element={<VerificationInProgress />}
          />
          <Route path="NewProvider" element={<NewProvider />} />
          <Route
            path="MonthlyMaintenInvoicesPreview/:invId"
            element={<MonthlyMaintenInvoicesPreview />}
          />
          <Route
            path="MiscellaneousInvoicesPreview/:invId"
            element={<MiscellaneousInvoicesPreview />}
          />
          <Route path="BuildingYes" element={<BuildingYes />} />
          <Route path="BuildingDetails" element={<BuildingDetails />} />
          <Route
            path="TenentManagInfoView/:tenentId"
            element={<TenentManagInfoView />}
          />
          <Route path="Tickets" element={<Tickets />} />
          <Route path="EditBuilding/:bid" element={<EditBuilding />} />
          <Route path="EditInvoice/:eid" element={<EditInvoice />} />
          <Route path="CreateNewTemplate" element={<CreateNewTemplate />} />
          <Route path="SendInvoiceTo" element={<SendInvoiceTo />} />
          <Route path="SendOtp" element={<SendOtp />} />
          <Route path="ChangePassword" element={<ChangePassword />} />
          <Route path="AllSociety" element={<AllSociety />} />
          <Route path="AssignRights" element={<AssignRights />} />
          <Route path="SocietyAdmin" element={<SocietyAdmin />} />
          <Route path="ManageSOS" element={<ManageSOS />} />
          <Route path="ApartmentHistory" element={<ApartmentHistory />} />
          <Route path="AddDutyPage" element={<AddDutyPage />} />
          <Route path="Aboutus" element={<Aboutus />} />
          <Route path="TechSupport" element={<TechSupport />} />
          <Route path="ServiceTypePage" element={<ServiceTypePage />} />
          <Route path="InOutLogs" element={<InOutLogs />} />
          <Route
            path="ServiceProviderHistory"
            element={<ServiceProviderHistory />}
          />
          <Route path="MasterCalculations" element={<MasterCalculations />} />
          <Route path="WaveLateFee/:invId" element={<WaveLateFee />} />

          <Route
            path="EditMiscellaneousInvoices/:eid"
            element={<EditMiscellaneousInvoices />}
          />
          <Route
            path="PrintMonthlyInvoice/:invId"
            element={<PrintMonthlyInvoice />}
          />
          <Route
            path="PrintMiscelliniousInvoice/:invId"
            element={<PrintMiscelliniousInvoice />}
          />

          {/* For Mobile Only */}
          <Route path="MobileLogin" element={<MobileLogin />} />
          <Route
            path="MobileForgotPassword"
            element={<MobileForgotPassword />}
          />
          <Route path="MobileDashboard" element={<MobileDashboard />} />
          <Route path="MobileProfile" element={<MobileProfile />} />
          <Route path="MobFamilyDetails" element={<MobFamilyDetails />} />

          <Route path="Apartment" element={<MobileApartment />} />
          <Route path="Emergency" element={<MobileEmergency />} />
          <Route path="Visitor" element={<MobileVisitor />} />
          <Route path="NoticeBoard" element={<MobileNoticeBoard />} />
          <Route path="NoticeBoardDetails" element={<MobileNoticeBoardDetails />} />
          <Route path="Complains" element={<MobileComplains />} />
          <Route path="MobileComplainDetails" element={<MobileComplainDetails />} />
          <Route path="Polls" element={<MobilePolls />} />
          <Route path="SupportTicket" element={<MobileSupportTicket />} />
          <Route path="MobileSupportTicketDetails" element={<MobileSupportTicketDetails />} />
          <Route path="UpcomingEvents" element={<MobileUpcomingEvents />} />
          <Route path="Invoice" element={<MobileInvoice />} />
          <Route path="MobileUnpaidInvoiceDetails" element={<MobileUnpaidInvoiceDetails />} />
          <Route path="MobilePayNow" element={<MobilePayNow />} />
          <Route path="MobileVisitorDetails" element={<MobileVisitorDetails />} />
          <Route path="MobileAddPreapproval" element={<MobileAddPreapproval />} />
          <Route path="MobileDiscussionForum" element={<MobileDiscussionForum />} />
          <Route path="MobileCreateDiscussionForum" element={<MobileCreateDiscussionForum />} />
          <Route path="MobileDiscussionDetails" element={<MobileDiscussionDetails />} />
          <Route path="MobileSosScreen" element={<MobileSosScreen />} />
          <Route path="MobileEditProfile" element={<MobileEditProfile />} />
          <Route path="MobileVehicleinfo" element={<MobileVehicleinfo />} />
          <Route path="OwnerVehicleDetails" element={<OwnerVehicleDetails />} />
          <Route path="MobileTenantInfo" element={<MobileTenantInfo />} />
          <Route path="MobileTenantDetails" element={<MobileTenantDetails />} />
          <Route path="MobileTenantVehicle" element={<MobileTenantVehicle />} />
          <Route path="MobileTenantVehicleDetails" element={<MobileTenantVehicleDetails />} />
          <Route path="MobileGroup" element={<MobileGroup />} />
          <Route path="MobileAddMember" element={<MobileAddMember />} />
          <Route path="MobileServiceProvider" element={<MobileServiceProvider />} />
          <Route path="MobileServiceProviderDetails" element={<MobileServiceProviderDetails />} />
          <Route path="MobileAddServiceProvider" element={<MobileAddServiceProvider />} />
          <Route path="MobileSpecificServiceProvider" element={<MobileSpecificServiceProvider />} />
          <Route path="MobileResidentDirectory" element={<MobileResidentDirectory />} />
          <Route path="MobileMarketPlaceBuyer" element={<MobileMarketPlaceBuyer />} />
          <Route path="MobileMarketPlaceSeller" element={<MobileMarketPlaceSeller />} />
          <Route path="MobileMarketDetailsBuyer" element={<MobileMarketDetailsBuyer />} />
          <Route path="MobileMarkerDetailsSeller" element={<MobileMarkerDetailsSeller />} />
          <Route path="MobileAddListing" element={<MobileAddListing />} />
          <Route path="MobileChatList" element={<MobileChatList />} />
          <Route path="MobileChatScreen" element={<MobileChatScreen />} />
          <Route path="MobileAddEvent" element={<MobileAddEvent />} />
          <Route path="MobileFoodOrderOption" element={<MobileFoodOrderOption />} />
          <Route path="MobileFoodOrder" element={<MobileFoodOrder />} />
          <Route path="MobileMyOrder" element={<MobileMyOrder />} />
          {/* Mobile End */}

          {/* For HomePage - Marketing Website */}
          {/* <Route path="HomePage" element={<HomePage />} /> */}
          <Route path="HomeTop" element={<HomeTop />} />
          <Route path="HomeFooter" element={<HomeFooter />} />
          <Route path="AdminFeatures" element={<AdminFeatures />} />
          <Route path="GuardFeatures" element={<GuardFeatures />} />
          <Route path="ResidentFeatures" element={<ResidentFeatures />} />
          <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="ResiproPrivacyPolicy" element={<ResiproPrivacyPolicy />} />

          <Route
            path="/notice/:noticeId"
            element={<Navigate to="/login" replace />}
          />
          {/* For HomePage - Marketing Website End*/}
        </Routes>
      </Router>
    </>
  );
}

export default App;
